export var InternetAndMediaType;
(function (InternetAndMediaType) {
    InternetAndMediaType["LinkedIn"] = "LinkedIn";
    InternetAndMediaType["Facebook"] = "Facebook";
    InternetAndMediaType["Twitter"] = "Twitter";
    InternetAndMediaType["YouTube"] = "YouTube";
    InternetAndMediaType["TikTok"] = "TikTok";
    InternetAndMediaType["Instagram"] = "Instagram";
    InternetAndMediaType["Pinterest"] = "Pinterest";
    InternetAndMediaType["GitHub"] = "GitHub";
    InternetAndMediaType["WorkRelated"] = "WorkRelated";
    InternetAndMediaType["StudiesRelated"] = "StudiesRelated";
    InternetAndMediaType["Private"] = "Private";
    InternetAndMediaType["Other"] = "Other";
})(InternetAndMediaType || (InternetAndMediaType = {}));
